<template>
  <div class="tinto-page">
    <Loading :isActive="loading" />

    <!-- ===== MODAL: TIMELINE DA OPERAÇÃO ===== -->
    <modal name="creditoTimeline" height="auto" width="700" :scrollable="true">
      <CloseModal :close="() => $modal.hide('creditoTimeline')" />
      <div class="modalbox">
        <div class="modalbox-content" v-if="reservaAberta">
          <h5 class="tinto-modal__title">
            <template v-if="reservaAberta.pedidoerp_id">Pedido {{ reservaAberta.pedidoerp_id }}</template>
            <template v-else>Orçamento {{ reservaAberta.orcamento_id }}</template>
            <span :class="['tinto-badge', 'ml-2', badgeSituacao(reservaAberta.situacao)]">
              {{ fraseSituacao(reservaAberta) }}
            </span>
          </h5>

          <p class="text-muted mb-3">
            Cliente {{ reservaAberta.cliente_id }} · usou
            <strong>{{ formatMoney(reservaAberta.valor_solicitado) }}</strong> em crédito
          </p>

          <div class="tinto-table-wrap">
            <table class="tinto-table">
              <thead><tr>
                <th style="width:150px">Quando</th>
                <th>O que aconteceu</th>
              </tr></thead>
              <tbody>
                <tr v-for="registro in timeline(reservaAberta)" :key="registro.id">
                  <td>{{ registro.quando | datetime }}</td>
                  <td>{{ registro.frase }}</td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </modal>

    <!-- ===== FILTROS ===== -->
    <div class="tinto-filters">
      <div class="tinto-filtros__linha">
        <div class="tinto-filtros__busca">
          <input
            class="form-control"
            v-model="filtros.q"
            placeholder="Orçamento, pedido ERP ou cliente..."
            @keyup.enter="load()"
          />
        </div>
        <div class="tinto-filtros__acoes">
          <button class="button button-primary button--icone" @click="load()" title="Buscar">
            <fa-icon icon="search" />
          </button>
          <button
            :class="['button', 'button--auto', filtrosAbertos ? 'button-primary' : '']"
            @click="filtrosAbertos = !filtrosAbertos"
          >
            <fa-icon icon="filter" /> Filtros
            <span v-if="totalFiltrosAtivos" class="tinto-filtros__contador">{{ totalFiltrosAtivos }}</span>
          </button>
        </div>
      </div>

      <div class="tinto-filtros__painel" v-if="filtrosAbertos">
        <CRow>
          <CCol md="3">
            <div class="tinto-campo">
              <label class="tinto-campo__label">Situação</label>
              <select class="form-control" v-model="filtros.situacoes" @change="load()">
                <option value="">Todas</option>
                <option v-for="(rotulo, situacao) in situacoes" :key="situacao" :value="situacao">
                  {{ rotulo }}
                </option>
              </select>
            </div>
          </CCol>
          <CCol md="3">
            <div class="tinto-campo">
              <label class="tinto-campo__label">Cliente</label>
              <input class="form-control" v-model="filtros.cliente_id" @keyup.enter="load()" />
            </div>
          </CCol>
          <CCol md="3">
            <div class="tinto-campo">
              <label class="tinto-campo__label">De</label>
              <input class="form-control" type="date" v-model="filtros.data_inicio" @change="load()" />
            </div>
          </CCol>
          <CCol md="3">
            <div class="tinto-campo">
              <label class="tinto-campo__label">Até</label>
              <input class="form-control" type="date" v-model="filtros.data_fim" @change="load()" />
            </div>
          </CCol>
        </CRow>
      </div>

      <div class="tinto-chips" v-if="chipsFiltros.length">
        <span class="tinto-chips__titulo">Filtrando por</span>
        <span class="tinto-filtro-chip" v-for="chip in chipsFiltros" :key="chip.chave">
          <strong>{{ chip.rotulo }}:</strong> {{ chip.valor }}
          <span class="tinto-filtro-chip__remover" @click="removerFiltro(chip.chave)" title="Remover filtro">&times;</span>
        </span>
        <button class="tinto-chips__limpar" @click="limparFiltros()">limpar tudo</button>
      </div>
    </div>

    <!-- ===== LISTAGEM ===== -->
    <div class="tinto-table-wrap">
      <table class="tinto-table">
        <thead><tr>
          <th style="width:145px">Quando</th>
          <th style="width:120px">Pedido ERP</th>
          <th style="width:90px">Cliente</th>
          <th style="width:130px">Crédito usado</th>
          <th style="width:120px">Troco</th>
          <th>Situação</th>
          <th style="width:210px">Ações</th>
        </tr></thead>
        <tbody>
          <tr v-if="items.length === 0">
            <td colspan="7" class="tinto-table__empty">
              Nenhuma movimentação de crédito para os filtros
            </td>
          </tr>
          <tr v-for="reserva in items" :key="reserva.id">
            <td>{{ reserva.datahora_criacao | datetime }}</td>
            <td class="tinto-table__primary">
              {{ reserva.pedidoerp_id || '—' }}
              <div class="tinto-table__sub">Orçamento: {{ reserva.orcamento_id }}</div>
            </td>
            <td>{{ reserva.cliente_id }}</td>
            <td>{{ formatMoney(reserva.valor_solicitado) }}</td>
            <td>
              <span v-if="reserva.valor_diferenca">{{ formatMoney(reserva.valor_diferenca) }}</span>
              <span v-else class="tinto-table__muted">—</span>
            </td>
            <td>
              <span :class="['tinto-badge', badgeSituacao(reserva.situacao)]">
                {{ fraseSituacao(reserva) }}
              </span>
            </td>
            <td>
              <div class="tinto-actions">
                <a href="#" class="mr-3 align-self-center" @click.prevent="verNaAuditoria(reserva.orcamento_id)">Ver auditoria</a>
                <button
                  class="button button-primary button--icone"
                  title="Ver a timeline da operação"
                  @click="abrirTimeline(reserva)"
                >
                  <fa-icon icon="eye" />
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="tinto-pagination" v-if="paginator.last_page > 1">
      <pagination :data="paginator" :limit="5" @pagination-change-page="load" />
    </div>
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import CloseModal from "../../components/CloseModal";
import listagemMixin from "../Tintometrico/listagemMixin";
import { SITUACOES, formatMoney } from "./helpers";

export default {
  name: "creditos-clientes-movimentacoes",
  components: { Loading, CloseModal },
  mixins: [listagemMixin],

  data() {
    return {
      listagemEndpoint: "/admin/creditos-clientes/reservas",
      sort: { by: "datahora_criacao", dir: "desc" },
      reservaAberta: null,
      filtros: {
        q: "", situacoes: "", cliente_id: "", data_inicio: "", data_fim: "",
      },
      rotulosFiltros: {
        q: "Busca", situacoes: "Situação", cliente_id: "Cliente",
        data_inicio: "De", data_fim: "Até",
      },
      situacoes: SITUACOES,
    };
  },

  methods: {
    appendFiltros(params) {
      Object.entries(this.filtros).forEach(([chave, valor]) => {
        if (valor !== "" && valor !== null) params.append(chave, valor);
      });
    },

    descreverFiltro(chave, valor) {
      if (chave === "situacoes") return this.situacoes[valor] || valor;
      return valor;
    },

    abrirTimeline(reserva) {
      this.reservaAberta = reserva;
      this.$modal.show("creditoTimeline");
    },

    verNaAuditoria(orcamentoId) {
      this.$emit("ver-auditoria", String(orcamentoId));
    },

    badgeSituacao(situacao) {
      if (situacao === "CONFIRMADA") return "tinto-badge--success";
      if (situacao === "ABERTA") return "tinto-badge--warn";
      if (situacao === "FALHA") return "tinto-badge--error";
      return "tinto-badge--muted";
    },

    fraseSituacao(reserva) {
      if (reserva.situacao === "CONFIRMADA" && reserva.pedidoerp_id) {
        return `Abatido no pedido ${reserva.pedidoerp_id}`;
      }
      return this.situacoes[reserva.situacao] || reserva.situacao;
    },

    /**
     * A história da operação: um registro por movimento do ledger, com a
     * frase em linguagem clara e a hora em que aconteceu.
     */
    timeline(reserva) {
      return (reserva.movimentos || []).map((movimento) => ({
        id: movimento.id,
        quando: movimento.datahora_criacao,
        frase: this.fraseMovimento(movimento, reserva),
      }));
    },

    fraseMovimento(movimento, reserva) {
      const money = this.formatMoney;
      const credito = movimento.credito_id ? `Crédito #${movimento.credito_id}` : "Crédito";

      switch (movimento.operacao) {
        case "RESERVA":
          if (!movimento.sucesso) {
            return movimento.mensagem
              ? `A reserva não se completou: ${movimento.mensagem}`
              : "A reserva não se completou no ERP";
          }
          return `${credito} de ${money(movimento.valor_antes)} separado para o pedido`;

        case "AJUSTE_VALOR":
          return `${credito} usado em parte: ${money(movimento.valor_depois)} de ${money(movimento.valor_antes)}` +
            " — a sobra vira troco";

        case "GERACAO_DIFERENCA":
          return `Troco de ${money(movimento.valor_depois)} devolvido como crédito novo` +
            (movimento.credito_id ? ` (#${movimento.credito_id})` : "");

        case "CONFIRMACAO":
          return `${credito} abatido no pedido ${movimento.pedidoerp_id || reserva.pedidoerp_id || ""}`.trim();

        case "LIBERACAO":
          return `${credito} devolvido ao saldo do cliente (${money(movimento.valor_depois)})`;

        case "BAIXA_DIFERENCA":
          return movimento.sucesso
            ? `Troco recolhido — o crédito do troco (#${movimento.credito_id}) foi removido`
            : "Troco mantido — já tinha sido usado por outro pedido";

        default:
          return movimento.mensagem || movimento.operacao;
      }
    },

    formatMoney,
  },
};
</script>
